import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './paragraphs.module.scss';
import './darkMode.css';
import Header from '../../../Home/components/Home/Header&CodeInput/HeaderStart';
import ChatApp from '../../../../components/ChatApp/ChatApp';
import { courseParagraph } from '../../../../http/coursesAPI';
import imageDefault from '../../../../assets/images/BoostDarkLogo.svg';
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner';
import paragraphs from "../../../TeacherCabinet/pages/paragraphs/Paragraphs"; // Импортируем кастомный спиннер

const Paragraphs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const courseId = location.state?.courseId; // Безопасный доступ к state
  const [themeData, setThemeData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!courseId) return;

    const fetchingThemes = async () => {
      try {
        const data = await courseParagraph(courseId);
        if (data.paragraphs) {
          setThemeData(data.paragraphs);
        }
      } catch (error) {
        console.error('Themes unavailable', error);
      } finally {
        setLoading(false);
      }
    };

    fetchingThemes();
  }, [courseId]);

  return (
    <div className={styles.paragraphs}>
      {/* Хедер всегда виден */}
      <Header />

      {/* Загружаем кастомный спиннер, если данные загружаются */}
      {loading ? (
        <div className="loading-container">
          <LoadingSpinner isLoading={loading} />
        </div>
      ) : (
        <div>
          <div className={styles.paragraphsTitle}>
            <h2>Параграфы</h2>
          </div>
          <div className={styles.list}>
            {themeData.length ? (
              themeData.map((theme) => (
                <div
                  key={theme.id}
                  className={`${styles.listContainer} themesListContainer`}
                  onClick={() =>
                    navigate(`/themes/${theme.id}`, {
                      state: { themeId: theme.id, ParagraphTitle: theme.title },
                    })
                  }
                >
                  <div className={styles.image}>
                    <img
                      src={theme.image_url > 0 ? theme.image_url : imageDefault}
                      alt={theme.title}
                    />
                  </div>

                  <div className={styles.information}>
                    <div className={`${styles.title} themesInformationTitle`}>
                      <h3>{theme.title}</h3>
                    </div>

                    <div className={styles.description}>
                      <p>{theme.description}</p>
                    </div>
                  </div>

                  <div className={`${styles.themes} themesCountInformation`}>
                    <p>Тем: {theme.theme_count}</p>
                  </div>
                </div>
              ))
            ) : (
              <p>Данные по этой теме отсутствуют...</p>
            )}
          </div>
        </div>
      )}

      {/* <ChatApp /> */}
    </div>
  );
};

export default Paragraphs;
